import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  name: 'Laura',
  location: 'Córdoba',
  text: 'Yo no sabía pintar ni dibujar, pero con las plantillas pude empezar tranquila. Hice mis primeros portavelas y quedaron hermosos.'
}, {
  name: 'Mariana',
  location: 'Rosario',
  text: 'Me encantó porque no necesitás comprar mil cosas. Empecé con frascos que tenía en casa y ahora estoy probando diseños para regalar.'
}, {
  name: 'Valeria',
  location: 'Buenos Aires',
  text: 'Lo compré como hobby, pero cuando subí mis primeras piezas a Instagram varias personas me preguntaron si las vendía.'
}, {
  name: 'Sofía',
  location: 'Mendoza',
  text: 'La guía es clara y práctica. Me ayudó a entender materiales, errores y cómo hacer que las piezas se vean más prolijas.'
}];
function TestimonialContent({
  testimonial,
  visible = true
}: {
  testimonial: (typeof testimonials)[number];
  visible?: boolean;
}) {
  return <div className={`bg-deco-card p-8 sm:p-12 rounded-[2rem] sm:rounded-[3rem] shadow-sm border border-deco-warm flex flex-col justify-center items-center text-center ${!visible ? 'invisible' : ''}`} data-id="element-181" data-mp="h4n3qbjitzax">
      <div className="flex gap-1 mb-6" data-id="element-182" data-mp="79lfdhx2l19e">
        {[...Array(5)].map((_, j) => <Star key={j} className="text-deco-gold fill-deco-gold w-5 h-5 sm:w-6 sm:h-6" data-id="element-183" data-mp="c7wn9n3t11oz" data-mpi={j} />)}
      </div>
      <p className="text-lg sm:text-xl md:text-2xl text-deco-text/90 leading-relaxed mb-8 font-normal italic px-2 sm:px-6" data-id="element-184" data-mp="zxh9qfz62h30">
        "{testimonial.text}"
      </p>
      <div className="flex flex-col items-center" data-id="element-185" data-mp="q6wdgz6yton9">
        <div className="w-12 h-12 bg-deco-bg rounded-full mb-3 border border-deco-warm flex items-center justify-center text-deco-terra font-serif font-bold text-xl" data-id="element-186" data-mp="q63ewli5u5g7">
          {testimonial.name.charAt(0)}
        </div>
        <p className="font-serif font-bold text-deco-text text-lg" data-id="element-187" data-mp="1it7e29uknpk2">
          {testimonial.name}
        </p>
        <p className="text-sm text-deco-taupe" data-id="element-188" data-mp="1nnv5aggymy2c">{testimonial.location}</p>
      </div>
    </div>;
}
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const nextTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentIndex(prevIndex => (prevIndex - 1 + testimonials.length) % testimonials.length);
  };
  useEffect(() => {
    const timer = setInterval(nextTestimonial, 6000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto overflow-hidden" data-id="element-189" data-mp="19rmtpfb67p1y">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-10 px-2" data-id="element-190" data-mp="14u4uigmygo75">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-4 font-bold leading-tight" data-id="element-191" data-mp="10s9s18tag4rs">
          Mujeres que ya empezaron a crear con sus manos
        </h2>
        <p className="text-base sm:text-lg text-deco-taupe font-medium" data-id="element-192" data-mp="vuhunz9vjqg7">
          Historias de mujeres que decidieron aprender una técnica nueva, crear
          piezas lindas y animarse a empezar desde casa.
        </p>
      </div>

      <div className="relative max-w-4xl mx-auto px-1 sm:px-12" data-id="element-193" data-mp="37f7f4tcd0sw8">
        <div className="relative" data-id="element-194" data-mp="3cf3lv0cfyyfh">
          <div aria-hidden="true" className="invisible" data-id="element-195" data-mp="3cetqsycji12x">
            <TestimonialContent testimonial={testimonials[currentIndex]} visible={false} data-id="element-196" data-mp="3cd90xm1676be" />
          </div>

          <div className="absolute inset-0" data-id="element-197" data-mp="2jqeisvrtsj13">
            <AnimatePresence mode="wait" data-id="element-198" data-mp="2jrpjgmpz5anz">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.4
            }} className="h-full" data-id="element-199" data-mp="2jol917lx1iov">
                <TestimonialContent testimonial={testimonials[currentIndex]} data-id="element-200" data-mp="210q1w6kt734q" />
              </motion.div>
            </AnimatePresence>
          </div>
        </div>

        <button onClick={prevTestimonial} className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10 -ml-2 sm:ml-0" aria-label="Previous testimonial" data-id="element-201" data-mp="24z5kzzdrrrcv">
          <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-202" data-mp="1vo9hascgfqr6" />
        </button>
        <button onClick={nextTestimonial} className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md border border-deco-warm text-deco-text hover:text-deco-terra transition-colors z-10 -mr-2 sm:mr-0" aria-label="Next testimonial" data-id="element-203" data-mp="1qvq6g355j9q2">
          <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6" data-id="element-204" data-mp="2elkem7ej0a3z" />
        </button>

        <div className="flex justify-center gap-3 mt-8" data-id="element-205" data-mp="2ejhrpw8o6x3h">
          {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-deco-terra w-8 sm:w-10' : 'bg-deco-warm hover:bg-deco-terra/50'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-206" data-mp="29n0veerbhcfb" data-mpi={idx} />)}
        </div>
      </div>
    </section>;
}